import * as React from "react";
const SvgFiRrFaceParty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-party_svg__a)">
      <path
        fill="#062147"
        d="M12.004.955c.05-.55.544-.96 1.086-.906 4.912.443 9.115 3.931 10.458 8.68a1 1 0 1 1-1.923.543c-1.12-3.956-4.621-6.862-8.714-7.23a1 1 0 0 1-.906-1.087zm5.45 19.428A9.96 9.96 0 0 1 12 22c-5.211 0-9.492-3.908-9.96-9.09a1 1 0 0 0-1.992.18C.61 19.31 5.748 24 12 24c2.334 0 4.598-.672 6.546-1.94a1 1 0 1 0-1.092-1.677M1.008 9.124l-1-8A.997.997 0 0 1 1.124.008l8 1A1 1 0 0 1 10 2c0 3.59-4.411 8-8 8a1 1 0 0 1-.992-.876M2.15 2.151l.716 5.721c2.053-.57 4.435-2.952 5.005-5.005zM21 12.001c-.811 0-1.598.334-2.16.917a1 1 0 1 0 1.439 1.39A1 1 0 1 1 21 16h-6.091c.056-.158.09-.325.09-.5 0-.828-.672-1.5-1.5-1.5H10a1 1 0 1 0 0 2h2.223c-.135.28-.222.613-.222 1 0 .385.087.72.222 1H10a1 1 0 1 0 0 2h3.5c.827 0 1.5-.674 1.5-1.5 0-.177-.035-.344-.091-.5h6.09c1.655 0 3-1.347 3-3 0-1.655-1.345-3-3-3m-3.727-2.652c-.35.402-.844.651-1.295.651h-.007c-.424-.002-.82-.219-1.18-.643a1.001 1.001 0 0 0-1.527 1.293c.939 1.107 1.984 1.346 2.695 1.35h.019c1.029 0 2.077-.5 2.807-1.34a1.001 1.001 0 0 0-1.512-1.31m-8 0c-.43.494-1.165.85-1.844.524a1.002 1.002 0 0 0-.86 1.807c.474.225.948.322 1.408.322 1.123 0 2.15-.586 2.807-1.343a1 1 0 1 0-1.51-1.31"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-party_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceParty;
